module.exports = __webpack_public_path__ + "img/forget-passMailUA.1cea61c5.png";